import axios from 'axios';
import { API_BASE_URL } from '../config';

export interface RegisterData {
  username: string;
  email: string;
  password: string;
  password2: string;
  language: string;
  email_notifications: boolean;
  sms_notifications: boolean;
  marketing_emails: boolean;
  marketing_sms: boolean;
}

export interface VerifyEmailData {
  username: string;
  verification_code: string;
}

export const register = async (data: RegisterData): Promise<void> => {
  try {
    await axios.post(`${API_BASE_URL}/v1/auth/register/`, data);
  } catch (error: any) {
    if (error.response?.data) {
      throw new Error(error.response.data.message || 'Registration failed');
    }
    throw new Error('Registration failed');
  }
};

export const verifyEmail = async (data: VerifyEmailData): Promise<void> => {
  try {
    await axios.post(`${API_BASE_URL}/v1/auth/verify_email/`, data);
  } catch (error: any) {
    if (error.response?.data) {
      throw new Error(error.response.data.message || 'Email verification failed');
    }
    throw new Error('Email verification failed');
  }
}; 